import { render, staticRenderFns } from "./coupon_expand.vue?vue&type=template&id=4bd9fa9e&scoped=true&"
import script from "./coupon_expand.vue?vue&type=script&lang=js&"
export * from "./coupon_expand.vue?vue&type=script&lang=js&"
import style0 from "./coupon_expand.vue?vue&type=style&index=0&id=4bd9fa9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9fa9e",
  null
  
)

export default component.exports